
import axios, { AxiosError } from 'axios';
import { POST_UPDATE_GROUP_URL } from '../../const/const';

interface UpdateGroupData {
    uid: string;
    name?: string;
    parent_uid?: string;
}

interface UpdateGroupResponse {
    success: boolean;
    error?: string;
    data?: any;
}

export const UpdateGroup = async (SmartDVRToken: string, userLogin: string, groupData: UpdateGroupData): Promise<UpdateGroupResponse> => {

    if (!userLogin || !SmartDVRToken) {
        console.error('User information is missing.');
        return { success: false, error: 'Отсутствует информация о пользователе' };
    }

    try {
        const response = await axios.post(
            POST_UPDATE_GROUP_URL,
            groupData,
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            });

        if (response.status === 200) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: 'Ошибка сервера' };
        }
    } catch (error) {
        const err = error as AxiosError;
        console.error('Error update group:', err.response?.status, err.response?.data);

        if (err.response?.status === 401) {
            return { success: false, error: 'Ошибка авторизации' };
        } else if (err.response?.status === 400) {
            return { success: false, error: 'Неверные данные запроса' };
        } else if (err.response?.status === 404) {
            return { success: false, error: 'Группа не найдена' };
        } else {
            return { success: false, error: 'Ошибка сети' };
        }
    }
};